export default __webpack_public_path__ + "static/media/placeholder_business06-nl-mobile.f8c917af.png";